import React, { useEffect, useState } from "react"
import "./recipes.css"
import { spoonacularApi } from "../../services/api/apiParams"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Alert from "react-bootstrap/Alert"
import ReactPaginate from "react-paginate"

import RecipesCard from "./RecipesCard"
import OffcanvasFiltersHoc from "./recipeFilters/OffcanvasFiltersHoc"

export const MyContext = React.createContext()

function Recipes() {
  const [recipes, setRecipes] = useState([])
  const [totalResults, setTotalResults] = useState(-1)
  const [searchDone, setSerchDone] = useState(false)
  const [search, setsearch] = useState(new URLSearchParams())
  //pagination
  const [pageCount, setPageCount] = useState(0)
  const [offset, setOffset] = useState(0)
  const [currentPage, setcurrentPage] = useState(0)
  const recipesPerPage = 9

  useEffect(() => {
    const fetchRecipes = async () => {
      let searchString = search.toString()
      const res = await spoonacularApi.get(
        `https://api.spoonacular.com/recipes/complexSearch?${searchString}`,
        {
          params: {
            number: recipesPerPage,
            offset: offset,
          },
        }
      )
      setTotalResults(res.data.totalResults)
      setRecipes(res.data.results)
    }
    fetchRecipes()
    window.scrollTo(0, 0)
  }, [searchDone, offset, currentPage])

  const searchBy = (key, value) => {
    // pagination
    setOffset(0)
    setcurrentPage(0)

    setSerchDone(!searchDone)
    return search.set(key, value)
  }

  const clearFilter = (key) => {
    //pagination
    setOffset(0)
    setcurrentPage(0)

    search.delete(key)
    return setSerchDone(!searchDone)
  }
  //pagination
  useEffect(() => {
    setPageCount(Math.ceil(totalResults / recipesPerPage))
  }, [totalResults])
  const changePage = (selectedObject) => {
    setcurrentPage(selectedObject.selected)
    setOffset(Math.ceil(selectedObject.selected * recipesPerPage))
  }
  return (
    <Container bsPrefix='recipesContainer'>
      <Row>
        <Col lg={8} id='recipesId'>
          {totalResults === 0 ? (
            <Alert className='mt-5 alert'>No recipe found</Alert>
          ) : totalResults >= 1 ? (
            <>
              <RecipesCard
                recipes={recipes}
                totalResults={totalResults}></RecipesCard>
              <ReactPaginate
                pageCount={pageCount}
                pageRangeDisplayed={0}
                marginPagesDisplayed={0}
                onPageChange={changePage}
                onPageActive={() => {}}
                containerClassName={"ReactPaginateContainer"}
                previousLinkClassName={"ReactPaginatePage"}
                breakClassName={"ReactPaginateHide"}
                nextLinkClassName={"ReactPaginatePage"}
                pageClassName={"ReactPaginatePage"}
                disabledClassName={"disabled"}
                activeClassName={"active"}
                forcePage={currentPage}
              />
            </>
          ) : (
            <Alert className='mt-5 alert'>Loading...</Alert>
          )}
        </Col>
        <Col lg={4} id='filtersId'>
          <MyContext.Provider value={{ searchBy, clearFilter }}>
            <OffcanvasFiltersHoc />
          </MyContext.Provider>
        </Col>
      </Row>
    </Container>
  )
}

export default Recipes
